import { ss } from '@/utils/storage'

const LOCAL_NAME = 'creditStorage'

export interface CreditData {
  user_id: string
  base_credit_balance: number
  advance_credit_balance: number
  total_credits_spent: number
  expired_wallets: number
}

export interface BillingConfig {
  id: number
  service_id: number
  api_path: string
  http_method: string
  billing_enabled: boolean
  required_credit_type: string
  fallback_credit_type: string | null
  billing_unit: string
  base_credit_cost: number
  advance_credit_cost: number
  credit_per_token: number
  credit_per_mb: number
  minimum_credit_cost: number
  tier_config: any
  description: string | null
  tags: string[] | null
  rate_limit: number | null
  burst_limit: number | null
  created_at: string
  updated_at: string
  created_by: string | null
  updated_by: string | null
  is_deleted: boolean
  target_type: string
  target_key: string
  code_config: string
}

export interface Service {
  service_id: number
  service_name: string
  service_code: string
  description: string | null
  base_url: string | null
  status: string
  version: string
  pricing_model: string
  default_credit_type: string
  allowed_credit_types: string[]
  base_price: number
  rate_limit: number
  created_at: string
  updated_at: string
  created_by: string
  updated_by: string | null
  is_deleted: boolean
}

export interface BillingConfigItem {
  config: BillingConfig
  service: Service
}

export interface CreditUsagePreview {
  credit_type?: 'basic_credit' | 'advance_credit' | string
  deducted_amount?: number
  balance?: number
  prompt_tokens?: number
  completion_tokens?: number
  total_tokens?: number
  model?: string
  updatedAt?: number
}

export interface CreditState {
  creditData: CreditData | null
  billingConfigs: BillingConfigItem[]
  isLoading: boolean
  lastUpdated: number | null
  isCreatedWallet: boolean
  usagePreview?: CreditUsagePreview | null
}

export function defaultSetting(): CreditState {
  return {
    creditData: null,
    billingConfigs: [],
    isLoading: false,
    lastUpdated: null,
    isCreatedWallet: false,
    usagePreview: null,
  }
}

export function getLocalState(): CreditState {
  const localSetting: CreditState | undefined = ss.get(LOCAL_NAME)
  return { ...defaultSetting(), ...localSetting }
}

export function setLocalState(setting: CreditState): void {
  ss.set(LOCAL_NAME, setting)
}
